module.exports = __webpack_public_path__ + "src/assets/img/lxwm_01@2x.f95ae791.png";